import callable from './callable';
/**
 * Returns a string of HTML classes.
 * Renders one or many component styles (objects of component parts) to the DOM.
 */
var getClasses = function (renderer, componentStyles, styleParam) {
    // root, icon, etc.
    var componentParts = Object.keys(componentStyles);
    return componentParts.reduce(function (classes, partName) {
        classes[partName] = renderer.renderRule(callable(componentStyles[partName]), styleParam);
        return classes;
    }, {});
};
export default getClasses;
